/**
 * DepartmentModern - MIGRATED to use CRUDPage template
 * 
 * Before: 264 lines
 * After: ~50 lines (81% reduction!)
 * 
 * This is an example of a simple CRUD page migration.
 * All standard CRUD operations are handled by the template.
 */

import React from 'react';
import { Box, Chip } from '@mui/material';
import { Building2 } from 'lucide-react';

import CRUDPage from '../Components/UI/CRUDPage';

// Field definitions
const departmentFields = [
  {
    name: 'department_code',
    label: 'Department Code',
    type: 'text',
    disabled: true,
    helperText: 'Auto-generated'
  },
  {
    name: 'name',
    label: 'Department Name',
    type: 'text',
    required: true,
    validation: {
      required: 'Department name is required',
      minLength: { value: 2, message: 'Department name must be at least 2 characters' }
    }
  }
];

// Column definitions
const columns = [
  {
    field: 'department_code',
    headerName: 'Department Code',
    sortable: true,
    renderCell: ({ value }) => (
      <Chip
        label={value || 'N/A'}
        size="small"
        variant="outlined"
        sx={{ fontWeight: 500 }}
      />
    )
  },
  {
    field: 'name',
    headerName: 'Department Name',
    sortable: true,
    renderCell: ({ value }) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Building2 size={16} color="primary.main" />
        <span style={{ fontWeight: 500 }}>{value}</span>
      </Box>
    )
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    align: 'right'
  }
];

function DepartmentModern() {
  return (
    <CRUDPage
      title="Department Management"
      subtitle="Manage organizational departments"
      icon={Building2}
      columns={columns}
      fields={departmentFields}
      searchFields={['name', 'department_code']}
      permissions={{
        resource: 'Admin',
        module: 'departments'
      }}
      crudConfig={{
        endpoint: '/api/departments',
        entityName: 'Department',
        entityNamePlural: 'Departments',
        useOrgId: true,
      }}
    />
  );
}

export default DepartmentModern;
